import React from 'react';
import { ShieldAlertIcon } from 'lucide-react';
export function CourseDescription() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-1243">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-1244">
        <div className="mb-12" data-id="element-1245">
          <h2 className="text-2xl md:text-3xl font-bold uppercase mb-6" style={{
          fontFamily: 'Oswald, sans-serif',
          color: '#1e3d2f'
        }} data-id="element-1246">
            About the Course
          </h2>
          <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm border" style={{
          borderColor: '#ede9e0'
        }} data-id="element-1247">
            <div className="flex items-start gap-4 mb-6" data-id="element-1248">
              <ShieldAlertIcon size={28} className="flex-shrink-0 mt-1" style={{
              color: '#1e3d2f'
            }} data-id="element-1249" />
              <p className="text-lg font-medium text-gray-900 leading-relaxed" style={{
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-1250">
                The Civilian Response to Active Shooter Events (CRASE) course
                provides non-firearms strategies, guidance, and a proven plan
                for surviving an active shooter event.
              </p>
            </div>
            <p className="text-base text-gray-800 leading-relaxed" style={{
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-1251">
              Topics include the history and prevalence of active shooter
              events, case/event studies, civilian response options, situational
              awareness scenarios, law enforcement response/arrival, medical
              issues, and considerations for independent skill development.
            </p>
          </div>
        </div>
      </div>
    </div>;
}